import { render, staticRenderFns } from "./Part1.vue?vue&type=template&id=a8146904&scoped=true"
import script from "./Part1.vue?vue&type=script&lang=js"
export * from "./Part1.vue?vue&type=script&lang=js"
import style0 from "./Part1.vue?vue&type=style&index=0&id=a8146904&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8146904",
  null
  
)

export default component.exports